/** 공용 강사 일정·레슨 예약 타입 (Asia/Seoul) */

export type ScheduleService = "lesson" | "realtime_feedback";

export type WeeklyRule = {
  /** 0(일) ~ 6(토) — Asia/Seoul 기준 */
  day: number;
  /** "09:00" */
  start: string;
  /** "22:00" */
  end: string;
};

export type ServiceSchedule = {
  slotMinutes: number;
  weeklyRules: WeeklyRule[];
  /** 휴무일 YYYY-MM-DD */
  blockedDates: string[];
  /** 당일 최소 예약 여유 (분) */
  minimumNoticeMinutes: number;
  /** 예약 가능 일수 */
  bookingWindowDays: number;
};

export type InstructorScheduleDoc = {
  instructorId: string;
  instructorName?: string;
  timezone: "Asia/Seoul";
  schemaVersion: 1;
  services: {
    lesson?: ServiceSchedule;
    realtime_feedback?: ServiceSchedule;
  };
  updatedAt?: unknown;
};

export type SlotOption = {
  date: string;
  time: string;
  instructorId: string;
  instructorName?: string;
  service: ScheduleService;
  durationMinutes: number;
};

export type LessonBookingStatus =
  | "hold"
  | "confirmed"
  | "cancelled"
  | "completed"
  | "expired";

export type LessonPaymentStatus = "pending" | "paid" | "refunded" | "failed";

export type LessonBooking = {
  id: string;
  bookingType: "lesson";
  instructorId: string;
  instructorName: string;
  studentId: string;
  studentName: string;
  studentEmail?: string | null;
  lessonTypeId: string;
  lessonTypeName: string;
  durationMinutes: number;
  priceKrw: number;
  date: string;
  time: string;
  /** ISO */
  startAt: string;
  /** ISO */
  endAt: string;
  timezone: "Asia/Seoul";
  status: LessonBookingStatus;
  paymentStatus: LessonPaymentStatus;
  holdExpiresAt?: string | null;
  paymentId?: string | null;
  orderId?: string | null;
  message?: string | null;
  lockKeys: string[];
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type BookingLock = {
  instructorId: string;
  date: string;
  time: string;
  bookingId: string;
  bookingType: "lesson" | "realtime_feedback";
  studentId: string;
  holdExpiresAt?: string | null;
  status: "hold" | "confirmed";
};

export const SCHEDULE_TIMEZONE = "Asia/Seoul" as const;
export const DEFAULT_SLOT_MINUTES = 30;
export const DEFAULT_NOTICE_MINUTES = 120;
export const DEFAULT_BOOKING_WINDOW_DAYS = 30;
export const HOLD_TTL_MINUTES = 15;
